import { ClassImporterExporter, ImportMap } from "@app/shared/resources/class-importer-exporter.service";
import { ConditionProviders } from "../conditions/condition";
import { Command, CommandData, CommandHelper, CommandProviders } from "./command";

export interface ApnsCommand extends Command {
    message: string;
}

export interface ApnsCommandData extends CommandData {
    message: string;
}

export class ApnsCommandHelper extends CommandHelper {
    static isValid(command: ApnsCommand): boolean {
        return !!(command.name?.length && command.message?.length);
    }

    static readonly importMap: ImportMap<ApnsCommand, ApnsCommandData> = [
        { i: "name", o: "name" },
        { i: "command_id", o: "commandId" },
        { i: "command_type", o: "commandType" },
        { i: "message", o: "message" },
    ];

    static fromCHObject(command): ApnsCommand {
        return {
            name: command[this.importMap[0].i],
            commandId: command[this.importMap[1].i],
            message: command[this.importMap[3].i],
            commandType: CommandProviders.PUSH,
        };
    }

    static exportObject(rule, command, importMap) {
        if (command.message.includes("${")) {
            if (
                rule.condition.conditionType === ConditionProviders.MULTI ||
                rule.condition.conditionType === ConditionProviders.PROPERTY_CHANGE
            ) {
                command.message = "${eventString} at ${event.time}";
            } else if (rule.condition.conditionType === ConditionProviders.UI_CONDITION) {
                command.message = "The " + rule.name + " scene was run (${event.time})";
            } else {
                command.message = "The " + rule.name + " schedule was run (${event.time})";
            }
        }

        return ClassImporterExporter.exportObject(command, importMap, false);
    }

    static getDefault(): ApnsCommand {
        return {
            name: "Send Mobile Notification",
            commandId: null,
            commandType: CommandProviders.PUSH,
            message: "${default}",
        };
    }
}
